const statusFor = (stepIndex, currentStep) => {
  if (stepIndex + 1 < currentStep) return "complete";
  if (stepIndex + 1 === currentStep) return "current";
  return "upcoming";
};

const suffixFor = status => {
  if (status === "current") return " (current)";
  if (status === "complete") return " (complete)";
  return "";
};

const Stepper = ({ steps, currentStep }) => (
  <ul
    role="list"
    aria-label="Import progress"
    className="tw:list-none tw:flex tw:items-center tw:gap-6 tw:p-0 tw:m-0"
  >
    {steps.map((step, index) => {
      const status = statusFor(index, currentStep);
      const ariaLabel = `Step ${index + 1} of ${steps.length}: ${step.label}${suffixFor(status)}`;
      return (
        <li
          key={step.id}
          role="listitem"
          data-status={status}
          aria-current={status === "current" ? "step" : undefined}
          className="tw:group tw:flex tw:items-center tw:gap-2 tw:font-sans tw:text-muted-foreground tw:data-[status=current]:text-foreground tw:data-[status=current]:font-semibold tw:data-[status=complete]:text-success"
        >
          <span
            aria-label={ariaLabel}
            className="tw:inline-flex tw:items-center tw:gap-2"
          >
            <span className="tw:inline-flex tw:items-center tw:justify-center tw:size-6 tw:rounded-full tw:bg-accent tw:text-muted-foreground tw:border tw:border-border tw:text-xs tw:font-semibold tw:group-data-[status=current]:bg-primary tw:group-data-[status=current]:text-primary-foreground tw:group-data-[status=current]:border-primary tw:group-data-[status=complete]:bg-success tw:group-data-[status=complete]:text-primary-foreground tw:group-data-[status=complete]:border-success">
              {status === "complete" ? "✓" : index + 1}
            </span>
            <span className="tw:text-sm">{step.label}</span>
          </span>
        </li>
      );
    })}
  </ul>
);

export default Stepper;
